module.exports = __webpack_public_path__ + "media/react/components/DailySequence/Slider/assets/steps-1161c416daa0abe937e4538b455ec5eb.svg";